module.exports = __webpack_public_path__ + "img/3.82f6972f.webp";